

import { Directive, ElementRef, HostListener } from '@angular/core'

@Directive({
  selector: '[ipv4Input]'
})
export class IPv4InputDirective {

  // Regular expression pattern for IPv4 with CIDR notation
  private ipv4Pattern = /^[0-9./]*$/

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement
    const inputValue = input.value

    if (!this.ipv4Pattern.test(inputValue)) {
      // Remove invalid characters
      input.value = inputValue.replace(/[^0-9./]/g, '')
    }
  }
}
